/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BikeleasingContractDetailsDTO } from '../dto';
// @ts-ignore
import { BikeleasingContractDownloadUrlDTO } from '../dto';
// @ts-ignore
import { BikeleasingCustomerDTO } from '../dto';
// @ts-ignore
import { BikeleasingDealerListDTO } from '../dto';
// @ts-ignore
import { BikeleasingNewsDTO } from '../dto';
// @ts-ignore
import { BikeleasingNewsListDTO } from '../dto';
// @ts-ignore
import { BikeleasingSettingsPatchRequestDTO } from '../dto';
// @ts-ignore
import { BikeleasingSettingsResponseDTO } from '../dto';
// @ts-ignore
import { BikeleasingV2ConditionResponseDTO } from '../dto';
// @ts-ignore
import { BikeleasingV2ContractsListDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * BikeleasingV2Api - axios parameter creator
 * @export
 */
export const BikeleasingV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Stream bikeleasing ELV PDF
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractElvFile: async (tenantId: string, contractId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('downloadContractElvFile', 'tenantId', tenantId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('downloadContractElvFile', 'contractId', contractId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/contracts/{contractId}/download-elv-file`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stream bikeleasing contract PDF
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFile: async (tenantId: string, contractId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('downloadContractFile', 'tenantId', tenantId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('downloadContractFile', 'contractId', contractId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/contracts/{contractId}/download-file`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single bikeleasing news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBikeleasingNewsArticle: async (tenantId: string, articleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBikeleasingNewsArticle', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getBikeleasingNewsArticle', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/news/{articleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the bikeleasing settings for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBikeleasingSettings: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBikeleasingSettings', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the bikeleasing condition for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCondition: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCondition', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/condition`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Bikeleasing Contract by ID
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractById: async (tenantId: string, contractId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getContractById', 'tenantId', tenantId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getContractById', 'contractId', contractId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/contracts/{contractId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve download url for all tenant contracts
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantContractsDownloadUrl: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTenantContractsDownloadUrl', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/contracts/download`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check whether bikeleasing ELV PDF is available
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headContractElvFile: async (tenantId: string, contractId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('headContractElvFile', 'tenantId', tenantId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('headContractElvFile', 'contractId', contractId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/contracts/{contractId}/download-elv-file`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check whether bikeleasing contract PDF is available
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headContractFile: async (tenantId: string, contractId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('headContractFile', 'tenantId', tenantId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('headContractFile', 'contractId', contractId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/contracts/{contractId}/download-file`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all Bikeleasing-Dealers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBikeleasingDealers: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listBikeleasingDealers', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/dealers`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all Bikeleasing-News
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBikeleasingNews: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listBikeleasingNews', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/news`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Bikeleasing Contracts for Tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContracts: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listContracts', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/contracts`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary submit the bikeleasing customer data
         * @param {string} tenantId 
         * @param {BikeleasingCustomerDTO} bikeleasingCustomerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCustomer: async (tenantId: string, bikeleasingCustomerDTO: BikeleasingCustomerDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('requestCustomer', 'tenantId', tenantId)
            // verify required parameter 'bikeleasingCustomerDTO' is not null or undefined
            assertParamExists('requestCustomer', 'bikeleasingCustomerDTO', bikeleasingCustomerDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/customer`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bikeleasingCustomerDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the editable bikeleasing settings for the tenant
         * @param {string} tenantId 
         * @param {BikeleasingSettingsPatchRequestDTO} bikeleasingSettingsPatchRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBikeleasingSettings: async (tenantId: string, bikeleasingSettingsPatchRequestDTO: BikeleasingSettingsPatchRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateBikeleasingSettings', 'tenantId', tenantId)
            // verify required parameter 'bikeleasingSettingsPatchRequestDTO' is not null or undefined
            assertParamExists('updateBikeleasingSettings', 'bikeleasingSettingsPatchRequestDTO', bikeleasingSettingsPatchRequestDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/bikeleasing_v2/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bikeleasingSettingsPatchRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BikeleasingV2Api - functional programming interface
 * @export
 */
export const BikeleasingV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BikeleasingV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Stream bikeleasing ELV PDF
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadContractElvFile(tenantId: string, contractId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadContractElvFile(tenantId, contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Stream bikeleasing contract PDF
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadContractFile(tenantId: string, contractId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadContractFile(tenantId, contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single bikeleasing news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBikeleasingNewsArticle(tenantId: string, articleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingNewsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBikeleasingNewsArticle(tenantId, articleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the bikeleasing settings for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBikeleasingSettings(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingSettingsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBikeleasingSettings(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the bikeleasing condition for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCondition(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingV2ConditionResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCondition(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve Bikeleasing Contract by ID
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractById(tenantId: string, contractId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingContractDetailsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractById(tenantId, contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve download url for all tenant contracts
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantContractsDownloadUrl(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingContractDownloadUrlDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantContractsDownloadUrl(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check whether bikeleasing ELV PDF is available
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async headContractElvFile(tenantId: string, contractId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.headContractElvFile(tenantId, contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check whether bikeleasing contract PDF is available
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async headContractFile(tenantId: string, contractId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.headContractFile(tenantId, contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all Bikeleasing-Dealers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBikeleasingDealers(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingDealerListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBikeleasingDealers(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all Bikeleasing-News
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBikeleasingNews(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingNewsListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBikeleasingNews(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve Bikeleasing Contracts for Tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContracts(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingV2ContractsListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContracts(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary submit the bikeleasing customer data
         * @param {string} tenantId 
         * @param {BikeleasingCustomerDTO} bikeleasingCustomerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestCustomer(tenantId: string, bikeleasingCustomerDTO: BikeleasingCustomerDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestCustomer(tenantId, bikeleasingCustomerDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update the editable bikeleasing settings for the tenant
         * @param {string} tenantId 
         * @param {BikeleasingSettingsPatchRequestDTO} bikeleasingSettingsPatchRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBikeleasingSettings(tenantId: string, bikeleasingSettingsPatchRequestDTO: BikeleasingSettingsPatchRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BikeleasingSettingsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBikeleasingSettings(tenantId, bikeleasingSettingsPatchRequestDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BikeleasingV2Api - factory interface
 * @export
 */
export const BikeleasingV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BikeleasingV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Stream bikeleasing ELV PDF
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractElvFile(tenantId: string, contractId: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadContractElvFile(tenantId, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stream bikeleasing contract PDF
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContractFile(tenantId: string, contractId: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadContractFile(tenantId, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single bikeleasing news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBikeleasingNewsArticle(tenantId: string, articleId: string, options?: any): AxiosPromise<BikeleasingNewsDTO> {
            return localVarFp.getBikeleasingNewsArticle(tenantId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the bikeleasing settings for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBikeleasingSettings(tenantId: string, options?: any): AxiosPromise<BikeleasingSettingsResponseDTO> {
            return localVarFp.getBikeleasingSettings(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the bikeleasing condition for the tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCondition(tenantId: string, options?: any): AxiosPromise<BikeleasingV2ConditionResponseDTO> {
            return localVarFp.getCondition(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Bikeleasing Contract by ID
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractById(tenantId: string, contractId: string, options?: any): AxiosPromise<BikeleasingContractDetailsDTO> {
            return localVarFp.getContractById(tenantId, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve download url for all tenant contracts
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantContractsDownloadUrl(tenantId: string, options?: any): AxiosPromise<BikeleasingContractDownloadUrlDTO> {
            return localVarFp.getTenantContractsDownloadUrl(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check whether bikeleasing ELV PDF is available
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headContractElvFile(tenantId: string, contractId: string, options?: any): AxiosPromise<void> {
            return localVarFp.headContractElvFile(tenantId, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check whether bikeleasing contract PDF is available
         * @param {string} tenantId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headContractFile(tenantId: string, contractId: string, options?: any): AxiosPromise<void> {
            return localVarFp.headContractFile(tenantId, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all Bikeleasing-Dealers
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBikeleasingDealers(tenantId: string, options?: any): AxiosPromise<BikeleasingDealerListDTO> {
            return localVarFp.listBikeleasingDealers(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all Bikeleasing-News
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBikeleasingNews(tenantId: string, options?: any): AxiosPromise<BikeleasingNewsListDTO> {
            return localVarFp.listBikeleasingNews(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Bikeleasing Contracts for Tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContracts(tenantId: string, options?: any): AxiosPromise<BikeleasingV2ContractsListDTO> {
            return localVarFp.listContracts(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary submit the bikeleasing customer data
         * @param {string} tenantId 
         * @param {BikeleasingCustomerDTO} bikeleasingCustomerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCustomer(tenantId: string, bikeleasingCustomerDTO: BikeleasingCustomerDTO, options?: any): AxiosPromise<void> {
            return localVarFp.requestCustomer(tenantId, bikeleasingCustomerDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the editable bikeleasing settings for the tenant
         * @param {string} tenantId 
         * @param {BikeleasingSettingsPatchRequestDTO} bikeleasingSettingsPatchRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBikeleasingSettings(tenantId: string, bikeleasingSettingsPatchRequestDTO: BikeleasingSettingsPatchRequestDTO, options?: any): AxiosPromise<BikeleasingSettingsResponseDTO> {
            return localVarFp.updateBikeleasingSettings(tenantId, bikeleasingSettingsPatchRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for downloadContractElvFile operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiDownloadContractElvFileRequest
 */
export interface BikeleasingV2ApiDownloadContractElvFileRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiDownloadContractElvFile
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiDownloadContractElvFile
     */
    readonly contractId: string
}

/**
 * Request parameters for downloadContractFile operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiDownloadContractFileRequest
 */
export interface BikeleasingV2ApiDownloadContractFileRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiDownloadContractFile
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiDownloadContractFile
     */
    readonly contractId: string
}

/**
 * Request parameters for getBikeleasingNewsArticle operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiGetBikeleasingNewsArticleRequest
 */
export interface BikeleasingV2ApiGetBikeleasingNewsArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiGetBikeleasingNewsArticle
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiGetBikeleasingNewsArticle
     */
    readonly articleId: string
}

/**
 * Request parameters for getBikeleasingSettings operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiGetBikeleasingSettingsRequest
 */
export interface BikeleasingV2ApiGetBikeleasingSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiGetBikeleasingSettings
     */
    readonly tenantId: string
}

/**
 * Request parameters for getCondition operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiGetConditionRequest
 */
export interface BikeleasingV2ApiGetConditionRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiGetCondition
     */
    readonly tenantId: string
}

/**
 * Request parameters for getContractById operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiGetContractByIdRequest
 */
export interface BikeleasingV2ApiGetContractByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiGetContractById
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiGetContractById
     */
    readonly contractId: string
}

/**
 * Request parameters for getTenantContractsDownloadUrl operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiGetTenantContractsDownloadUrlRequest
 */
export interface BikeleasingV2ApiGetTenantContractsDownloadUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiGetTenantContractsDownloadUrl
     */
    readonly tenantId: string
}

/**
 * Request parameters for headContractElvFile operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiHeadContractElvFileRequest
 */
export interface BikeleasingV2ApiHeadContractElvFileRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiHeadContractElvFile
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiHeadContractElvFile
     */
    readonly contractId: string
}

/**
 * Request parameters for headContractFile operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiHeadContractFileRequest
 */
export interface BikeleasingV2ApiHeadContractFileRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiHeadContractFile
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiHeadContractFile
     */
    readonly contractId: string
}

/**
 * Request parameters for listBikeleasingDealers operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiListBikeleasingDealersRequest
 */
export interface BikeleasingV2ApiListBikeleasingDealersRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiListBikeleasingDealers
     */
    readonly tenantId: string
}

/**
 * Request parameters for listBikeleasingNews operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiListBikeleasingNewsRequest
 */
export interface BikeleasingV2ApiListBikeleasingNewsRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiListBikeleasingNews
     */
    readonly tenantId: string
}

/**
 * Request parameters for listContracts operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiListContractsRequest
 */
export interface BikeleasingV2ApiListContractsRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiListContracts
     */
    readonly tenantId: string
}

/**
 * Request parameters for requestCustomer operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiRequestCustomerRequest
 */
export interface BikeleasingV2ApiRequestCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiRequestCustomer
     */
    readonly tenantId: string

    /**
     * 
     * @type {BikeleasingCustomerDTO}
     * @memberof BikeleasingV2ApiRequestCustomer
     */
    readonly bikeleasingCustomerDTO: BikeleasingCustomerDTO
}

/**
 * Request parameters for updateBikeleasingSettings operation in BikeleasingV2Api.
 * @export
 * @interface BikeleasingV2ApiUpdateBikeleasingSettingsRequest
 */
export interface BikeleasingV2ApiUpdateBikeleasingSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingV2ApiUpdateBikeleasingSettings
     */
    readonly tenantId: string

    /**
     * 
     * @type {BikeleasingSettingsPatchRequestDTO}
     * @memberof BikeleasingV2ApiUpdateBikeleasingSettings
     */
    readonly bikeleasingSettingsPatchRequestDTO: BikeleasingSettingsPatchRequestDTO
}

/**
 * BikeleasingV2Api - object-oriented interface
 * @export
 * @class BikeleasingV2Api
 * @extends {BaseAPI}
 */
export class BikeleasingV2Api extends BaseAPI {
    /**
     * 
     * @summary Stream bikeleasing ELV PDF
     * @param {BikeleasingV2ApiDownloadContractElvFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public downloadContractElvFile(requestParameters: BikeleasingV2ApiDownloadContractElvFileRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).downloadContractElvFile(requestParameters.tenantId, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stream bikeleasing contract PDF
     * @param {BikeleasingV2ApiDownloadContractFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public downloadContractFile(requestParameters: BikeleasingV2ApiDownloadContractFileRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).downloadContractFile(requestParameters.tenantId, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single bikeleasing news article
     * @param {BikeleasingV2ApiGetBikeleasingNewsArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public getBikeleasingNewsArticle(requestParameters: BikeleasingV2ApiGetBikeleasingNewsArticleRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).getBikeleasingNewsArticle(requestParameters.tenantId, requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the bikeleasing settings for the tenant
     * @param {BikeleasingV2ApiGetBikeleasingSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public getBikeleasingSettings(requestParameters: BikeleasingV2ApiGetBikeleasingSettingsRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).getBikeleasingSettings(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the bikeleasing condition for the tenant
     * @param {BikeleasingV2ApiGetConditionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public getCondition(requestParameters: BikeleasingV2ApiGetConditionRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).getCondition(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Bikeleasing Contract by ID
     * @param {BikeleasingV2ApiGetContractByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public getContractById(requestParameters: BikeleasingV2ApiGetContractByIdRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).getContractById(requestParameters.tenantId, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve download url for all tenant contracts
     * @param {BikeleasingV2ApiGetTenantContractsDownloadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public getTenantContractsDownloadUrl(requestParameters: BikeleasingV2ApiGetTenantContractsDownloadUrlRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).getTenantContractsDownloadUrl(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check whether bikeleasing ELV PDF is available
     * @param {BikeleasingV2ApiHeadContractElvFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public headContractElvFile(requestParameters: BikeleasingV2ApiHeadContractElvFileRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).headContractElvFile(requestParameters.tenantId, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check whether bikeleasing contract PDF is available
     * @param {BikeleasingV2ApiHeadContractFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public headContractFile(requestParameters: BikeleasingV2ApiHeadContractFileRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).headContractFile(requestParameters.tenantId, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all Bikeleasing-Dealers
     * @param {BikeleasingV2ApiListBikeleasingDealersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public listBikeleasingDealers(requestParameters: BikeleasingV2ApiListBikeleasingDealersRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).listBikeleasingDealers(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all Bikeleasing-News
     * @param {BikeleasingV2ApiListBikeleasingNewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public listBikeleasingNews(requestParameters: BikeleasingV2ApiListBikeleasingNewsRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).listBikeleasingNews(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Bikeleasing Contracts for Tenant
     * @param {BikeleasingV2ApiListContractsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public listContracts(requestParameters: BikeleasingV2ApiListContractsRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).listContracts(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary submit the bikeleasing customer data
     * @param {BikeleasingV2ApiRequestCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public requestCustomer(requestParameters: BikeleasingV2ApiRequestCustomerRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).requestCustomer(requestParameters.tenantId, requestParameters.bikeleasingCustomerDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the editable bikeleasing settings for the tenant
     * @param {BikeleasingV2ApiUpdateBikeleasingSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BikeleasingV2Api
     */
    public updateBikeleasingSettings(requestParameters: BikeleasingV2ApiUpdateBikeleasingSettingsRequest, options?: AxiosRequestConfig) {
        return BikeleasingV2ApiFp(this.configuration).updateBikeleasingSettings(requestParameters.tenantId, requestParameters.bikeleasingSettingsPatchRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
